export default __webpack_public_path__ + "static/media/Landing-Packages-Hospital.7d2d30fe.svg";